import { render, staticRenderFns } from "./ab-upload3.vue?vue&type=template&id=2caad0b3&scoped=true"
import script from "./ab-upload3.vue?vue&type=script&lang=js"
export * from "./ab-upload3.vue?vue&type=script&lang=js"
import style0 from "./ab-upload3.vue?vue&type=style&index=0&id=2caad0b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caad0b3",
  null
  
)

export default component.exports